import * as Yup from 'yup';
export const initialValues = {
  notes: '',
};
export const validationSchema = Yup.object({
  notes: Yup.string().required('dashboard.string18'),
});

export const initialValuesOfStaffNotes = {
  staff_note: '',
  date: 'now',
};
export const validationSchemaOfStaffNotes = Yup.object({
  staff_note: Yup.string().required('dashboard.string18'),
});

export const initialValuesOfClosedTicket = {
  closed_reopen_summary: '',
};
export const validationSchemaOfClosedTicket = Yup.object({
  closed_reopen_summary: Yup.string().required('dashboard.string18'),
});

export const handleKeyDown = (event, handleSubmit) => {
  if (event.ctrlKey && event.key === 'Enter') {
    event.preventDefault();
    handleSubmit();
  }
};

export const initialValuesOfCreateTickets = {
  emailID: '',
  username: '',
  dept: '',
  subject: '',
  message: '',
  note: '',
  secret: '',
};

export const validationSchemaOfCreateTickets = Yup.object({
  username: Yup.string().required('admin/tickets/create.string1'),
  dept: Yup.string().required('admin/tickets/create.string2'),
  subject: Yup.string().required('admin/tickets/create.string3'),
  message: Yup.string().required('admin/tickets/create.string3'),
  emailID: Yup.string().required('admin/tickets/create.string2'),
});

export const checkbox = [
  {
    id: 'nonbillingcontacts',
    content: 'step1_string6',
  },
  {
    id: 'billingcontacts',
    content: 'step1_string7',
  },
  {
    id: 'allcontacts',
    content: 'step1_string8',
  },
];
